// extracted by mini-css-extract-plugin
module.exports = {"inner":"cTAInner_inner__zEeSi","hide":"cTAInner_hide__ltUrf"};